import { MessageCircle } from 'lucide-react';
import { COMPANY } from '../lib/site';

export const FloatingWhatsApp = () => {
    const href = `https://wa.me/${COMPANY.whatsapp}?text=${encodeURIComponent(COMPANY.whatsappMessage)}`;
    return (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="whatsapp-floating-button"
            className="fixed bottom-6 right-6 z-40 group"
            aria-label="Chat on WhatsApp"
        >
            <span className="relative grid place-items-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-[0_12px_30px_-8px_rgba(37,211,102,0.6)] transition-transform group-hover:scale-105">
                <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
                <MessageCircle className="w-6 h-6 relative" strokeWidth={1.8} />
            </span>
            <span className="hidden md:block absolute right-16 top-1/2 -translate-y-1/2 whitespace-nowrap bg-primary text-primary-foreground text-xs font-outfit px-3 py-1.5 rounded-full opacity-0 group-hover:opacity-100 transition-opacity">
                Chat on WhatsApp
            </span>
        </a>
    );
};
